let searchRequestModel = {
  keywords: null,
  campaignCode: null,
  department: null,
  erecruitid: null,
  city: null,
  state: null,
  positionType: null,
  postalCode: null,
  distanceInMiles: 0,
  page: 0,
  resultsPerPage: 10,
  sortColumn: "DatePosted",
  sortDirection: "desc"
}

export default searchRequestModel
